import { styled, css } from 'styled-components'

type BlurryBackroundProp = {
  $display: boolean
  $backgroundColor?: string
  $backdropFilter?: string
}

export const BlurryBackground = styled.div<BlurryBackroundProp>`
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  min-height: 100%;
  opacity: 1;
  background-color: ${({ $backgroundColor }) =>
    $backgroundColor || 'rgba(255, 255, 255, 0.65)'};
  backdrop-filter: ${({ $backdropFilter }) => $backdropFilter || 'blur(25px)'};
  z-index: 1500;
  transition: opacity 0.25s ease-in-out;
  cursor: auto;
  display: flex;
  ${({ $display }) =>
    !$display &&
    css`
      opacity: 0;
      pointer-events: none;
      touch-action: none;
    `}
`
